import { MinusCircleOutlined } from '@ant-design/icons'
import { colors, Flex } from '@weareberyl/design-system'
import { Descriptions, Tag } from 'antd'
import { capitalCase } from 'change-case'
import { ReactNode, useCallback } from 'react'
import useSchemes from '~/components/Scheme/useSchemes'
import {
  AutomationFlowsQuery_sourced_automation_flows_SourcedAutomationFlow_source_AutomationSource_filters_AutomationFlowFilter as Filter,
  FilterType,
} from '~/gql/generated/graphql'

interface IAutomationFilter {
  filter: Filter
}

interface ITypedFilter extends IAutomationFilter {
  renderValue: (value: string) => ReactNode
  label: string
}

const TypedFilter = ({ filter, renderValue, label }: ITypedFilter) => (
  <Descriptions bordered size="small">
    <Descriptions.Item
      label={label}
      labelStyle={{ width: 140 }}
      style={{ padding: 5 }}
    >
      <Flex flexDirection="row" width="100%" style={{ gap: 2 }}>
        {filter.entries.map(v => (
          <Tag
            icon={filter.not__ ? <MinusCircleOutlined /> : undefined}
            color={filter.not__ ? colors.prawn : colors.mint}
            key={v}
            style={{
              color: filter.not__ ? colors.alert : colors.pickle,
            }}
          >
            {renderValue(v)}
          </Tag>
        ))}
      </Flex>
    </Descriptions.Item>
  </Descriptions>
)

const AutomationFilter = ({ filter }: IAutomationFilter) => {
  const { allSchemes } = useSchemes()
  const schemeLookup = useCallback(
    (scheme_id: string) => allSchemes.find(({ id }) => id === scheme_id)?.name,
    [allSchemes],
  )

  switch (filter.filter_type) {
    case FilterType.frame_type:
      return (
        <TypedFilter
          label="Frame Type"
          filter={filter}
          renderValue={capitalCase}
        />
      )
    case FilterType.hardware_type:
      return (
        <TypedFilter
          label="Hardware Type"
          filter={filter}
          renderValue={capitalCase}
        />
      )
    case FilterType.scheme_id:
      return (
        <TypedFilter
          label="Scheme"
          filter={filter}
          renderValue={schemeLookup}
        />
      )
    default:
      return null
  }
}

const AutomationFilters = ({ filters }: { filters: Filter[] | null }) => {
  if (!filters) return null

  return (
    <Flex flexDirection="column" style={{ gap: 5, maxWidth: 500 }}>
      {filters.map(f => (
        <AutomationFilter filter={f} key={`${f.not__}${f.filter_type}`} />
      ))}
    </Flex>
  )
}

export default AutomationFilters
